import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

interface CustomRequestConfig extends InternalAxiosRequestConfig {
  hash?: string;
  hashToken?: string;
}

const FN_CONFIG = (window as any).FN_CONFIG;

// Utility function to create Axios instances
const getAxiosInstance = (baseUrl: string): AxiosInstance => axios.create({ baseURL: baseUrl });

const IdaasAxiosInstance = getAxiosInstance(FN_CONFIG.OIDC_CONFIGURATION.authority);
const FnAxiosInstance = getAxiosInstance(FN_CONFIG.FN_API_URL);
const ImsAxiosInstance = getAxiosInstance(FN_CONFIG.IMS_API_URL);
const SearchAxiosInstance = getAxiosInstance(FN_CONFIG.SEARCH_API_URL);
const DocumentsAxiosInstance = getAxiosInstance(FN_CONFIG.DOCUMENTS_API_URL);

const axiosInstances = [
  IdaasAxiosInstance,
  FnAxiosInstance,
  ImsAxiosInstance,
  SearchAxiosInstance,
  DocumentsAxiosInstance,
];

// BucketHttpClient handles specific headers
const BucketHttpClient = axios.create({
  headers: { Accept: 'application/json' },
});

BucketHttpClient.interceptors.request.use((request: CustomRequestConfig) => {
  if (request.headers) {
    request.headers['x-document-context'] = request.hash;
    request.headers['x-amz-meta-document-security'] = request.hashToken;
  }
  return request;
});

// Function to initialize interceptors for each Axios instance
export const initInterceptors = (access_token: string) => {
  for (const instance of axiosInstances) {
    // Clear old interceptors
    instance.interceptors.response.clear();
    instance.interceptors.request.clear();

    // Add response interceptor to handle 401 errors
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          console.log('Intercepted a 401 response. Directing user to login page.');
          // You can trigger a page reload or redirect to login here
          // window.location.reload();
        } else {
          return Promise.reject(error);
        }
      }
    );

    // Add request interceptor to attach the access token
    instance.interceptors.request.use(
      (config) => {
        const token = access_token;
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
};

export {
  axios,
  IdaasAxiosInstance,
  FnAxiosInstance,
  ImsAxiosInstance,
  SearchAxiosInstance,
  DocumentsAxiosInstance,
  BucketHttpClient,
};
